import Footer from 'components/Footer';
import Head from 'components/Head';
import Banner from 'components/Banner';
import Navbar from 'components/Navbar';
import React, { PropsWithChildren } from 'react';

import 'bootstrap/dist/css/bootstrap.min.css';
// TODO: Preload the font
// https://github.com/fontsource/fontsource/issues/83#issuecomment-1110733629
import "@fontsource/nunito";
import "@fontsource/nunito/800.css";

import 'styles/theme.css';
import 'styles/custom.css';

interface LayoutProps {
    /**
     * The path for this current page.
     *
     * This does not contain the domain name (you can use the useSiteMetadata
     * hook to get the domain name), but otherwise this is the full path for the
     * page currently being rendered.
     *
     * Can be missing (e.g when rendering the 404 page).
     */
    path?: string;
    /** The title of this page */
    title?: string;
    /** An optional description of this page */
    description?: string;
    /** If true, show any temporary sitewide banners on this page */
    shouldShowBanner?: boolean;
    shouldShowDownloads?: boolean;
}

const Layout: React.FC<PropsWithChildren<LayoutProps>> = (props) => {
    return (
        <>
            <Head {...props} />
            {<Banner />}
            <Navbar {...props} />
            <main className="main-container">{props.children}</main>
            <Footer {...props} />
        </>
    );
};

export default Layout;
